module.exports = __webpack_public_path__ + "img/cart_icon.88bfaa2c.svg";